export const productSeriesConf: Record<string, { productId: string; variantId: string }[]> = {
    jp: [
        {
            productId: '14776028856687',
            variantId: '52157995123055',
        },
        {
            productId: '14775578952047',
            variantId: '52156760129903',
        },
        {
            productId: '14776029217135',
            variantId: '52157995680111',
        },
        {
            productId: '14776030626159',
            variantId: '52157998104943',
        },
        {
            productId: '14776030986607',
            variantId: '52158000202095',
        },
        {
            productId: '14776031871343',
            variantId: '52158005084527',
        },
        {
            productId: '14776034918767',
            variantId: '52158022943087',
        },
        {
            productId: '14776034132335',
            variantId: '52158019797359',
        },
    ],
};